import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CommonLocationIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<g clipPath='url(#clip0_7414_13956)'>
				<path
					d='M18 6V6.01'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth='2'
				/>
				<path
					d='M18 13L14.5 7.99997C14.1631 7.391 13.9909 6.70466 14.0004 6.00876C14.0099 5.31287 14.2008 4.63149 14.5543 4.03197C14.9077 3.43245 15.4115 2.93552 16.0158 2.59029C16.6201 2.24506 17.304 2.06348 18 2.06348C18.696 2.06348 19.3799 2.24506 19.9842 2.59029C20.5885 2.93552 21.0923 3.43245 21.4457 4.03197C21.7992 4.63149 21.9901 5.31287 21.9996 6.00876C22.0091 6.70466 21.8369 7.391 21.5 7.99997L18 13Z'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M10.5 4.75L9 4L3 7V20L9 17L15 20L21 17V15'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M9 4V17'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M15 15V20'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id='clip0_7414_13956'>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default CommonLocationIcon;
